import {useEffect} from "react";

export default function useBlockScroll(isBlocked = true) {
    useEffect(() => {
        const bodyElm = document.getElementsByTagName('body')[0];
        bodyElm.style.overflow = isBlocked
            ? "hidden"
            : "auto"

        return () => {
            bodyElm.style.overflow = 'auto';
        }
    }, [isBlocked]);
}
